import Home from './home'

const routes = [
  {
    path: '',
    name: 'home',
    component: Home,
    meta: {
      hideHeaderSearch: true
    }
  }
]

export default routes
